import { selectFromUserDto } from '../../models';

export default selectFromUserDto()
  .id
  .projectsCount
  .defaultWorkspaceId
  .toString();
